











































































































































































































import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import { IBasketProduct } from "@/models/baskets";
import {
  IInvoiceCreditRefundProvider,
  IInvoiceCreditRefundProviderMethods
} from "@/models/providers/invoiceCreditRefund";
import { IInvoiceProduct } from "@/models/invoices";
import { DataModules } from "@/store/modules/data";

@Component
export default class InvoiceCreditItemsTable extends Vue {
  @Inject({ from: "invoiceCreditRefundProvider" })
  public readonly $invoiceCreditRefundProviderData!: () => IInvoiceCreditRefundProvider;

  @Inject({ from: "invoiceCreditRefundProviderMethods" })
  public readonly $invoiceCreditRefundProviderMethods!: IInvoiceCreditRefundProviderMethods;

  public totalProducts = 0;
  public allChecked = true;
  public checkedProducts: IBasketProduct[] = [];
  public productAmounts: { [key: string]: number } = {};

  // Computed
  public get providerData() {
    return this.$invoiceCreditRefundProviderData();
  }

  @Watch("checkedProducts", { deep: true })
  public onCheckedProductsChanged() {
    this.emitData();
    this.allChecked = this.checkedProducts.length === this.totalProducts;
  }

  @Watch("productAmounts", { deep: true })
  public onProductAmountsChanged() {
    this.emitData();
  }

  @Watch("providerData.isLoading", { immediate: true })
  public setProductAmounts() {
    this.providerData.invoice.products.forEach(product => {
      if (product.partial_amount_to_credit_converted) {
        this.checkedProducts.push(product);
        this.$set(
          this.productAmounts,
          product.id,
          product.partial_amount_to_credit_converted
        );
      }
      product.options.forEach(option => {
        if (option.partial_amount_to_credit_converted) {
          this.checkedProducts.push(option);
          this.$set(
            this.productAmounts,
            option.id,
            option.partial_amount_to_credit_converted
          );
        }
      });
    });
    this.totalProducts = this.checkedProducts.length;
  }

  public emitData() {
    const productAmounts: { [key: string]: number } = {};
    this.providerData.invoice.products.forEach(product => {
      if (
        this.checkedProducts.includes(product) &&
        this.productAmounts[product.id]
      ) {
        productAmounts[product.id] = this.productAmounts[product.id];
      }
      product.options.forEach(option => {
        if (
          this.checkedProducts.includes(option) &&
          this.productAmounts[option.id]
        ) {
          productAmounts[option.id] = this.productAmounts[option.id];
        }
      });
    });

    this.$emit("amounts-changed", productAmounts);
  }

  public getProductName(invoiceProduct: IInvoiceProduct) {
    return this.$store.getters[`data/${DataModules.CONTRACTS_PRODUCTS}/name`](
      invoiceProduct
    );
  }

  public toggleAll(value) {
    this.checkedProducts = [];
    if (!value) {
      return;
    }
    this.providerData.invoice.products.forEach(product => {
      if (product.partial_amount_to_credit_converted) {
        this.checkedProducts.push(product);
      }
      product.options.forEach(option => {
        if (option.partial_amount_to_credit_converted) {
          this.checkedProducts.push(option);
        }
      });
    });
  }
}
